import React from "react";
import { bool, elementType, oneOf, oneOfType, string } from "prop-types";
import { classes } from "../utils/classes";
import pureFC from "../utils/pureFC";
import fontWeight from "../utils/fontWeight";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";
import { colorPropTypes, fontSizePropTypes, sxClassName, sxProps, sxPropTypes } from "../props/sx";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";

const Heading = ({
	Tag = "h2",
	size,
	color,
	weight,
	center,
	uppercase = false,
	className,
	italic,
	utility = { ...utilityProps },
	spacing = { ...spacingProps },
	sx = { ...sxProps },
	...props
}) => {
	const isHeading = true;
	return (
		<Tag
			className={classes(
				"heading",
				size && `heading-${size}`,
				weight && fontWeight[weight],
				center && "text-center",
				italic && "text-italic",
				uppercase && "text-uppercase",
				color && `text-color-${color}`,
				...utilityClassName(utility),
				...sxClassName(sx, isHeading),
				...spacingClassName(spacing),
				className,
			)}
			{...props}
		/>
	);
};

Heading.propTypes = {
	Tag: oneOfType([oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]), elementType]),
	size: fontSizePropTypes,
	center: bool,
	italic: bool,
	uppercase: bool,
	weight: oneOf(Object.keys(fontWeight)),
	color: colorPropTypes,
	className: string,
	utility: utilityPropTypes,
	spacing: spacingPropTypes,
	sx: sxPropTypes,
};

export default pureFC(Heading);
